import type { UploadRequestFn } from "@/types";

export interface XGroupUploadRequestOptions {
  url: string;
  token?: string;
  appNo?: string;
}

/** 众安信科预设上传：upload=true 且具备 appNo/token 时可自动接入默认附件接口。 */
export const createXGroupUploadRequest = ({
  url,
  token,
  appNo,
}: XGroupUploadRequestOptions): UploadRequestFn | undefined => {
  if (!appNo || !token) return undefined;

  return async ({ file, onProgress, onSuccess, onError }) => {
    try {
      onProgress?.({ percent: 0 });

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        `${url}/api/gateway-web/openApi/v1/aizt/app/${appNo}/uploadMultiFile`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
          },
        },
      );

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result?.message || `文件上传失败 (${response.status})`);
      }

      const uploadedFile = Array.isArray(result?.data)
        ? result.data[0]
        : (result?.data ?? result);

      onProgress?.({ percent: 100 });
      onSuccess?.(uploadedFile);
    } catch (error) {
      onError?.(error instanceof Error ? error : new Error("文件上传失败"));
    }
  };
};
